import { type DsBadgeProps } from '@/components/design-system/badge/DsBadge.vue';
import { Insurance } from '@/types/closinglock.types.js';
import InsuranceBadgeBase from './InsuranceBadgeBase.vue';
import InsuranceBadgeBav from './InsuranceBadgeBav.vue';
import InsuranceBadgeDefault from './InsuranceBadgeDefault.vue';

const InsuranceBadge = InsuranceBadgeBase as typeof InsuranceBadgeBase & {
    Default: typeof InsuranceBadgeDefault;
    Bav: typeof InsuranceBadgeBav;
};

InsuranceBadge.Default = InsuranceBadgeDefault;
InsuranceBadge.Bav = InsuranceBadgeBav;

const NOT_INSURED_PROPS = {
    text: 'Not insured',
    variant: 'error',
    icon: 'fa-solid fa-shield-exclamation',
} satisfies DsBadgeProps;

export const BASE_INSURANCE_BADGE_MAP: Record<Insurance, DsBadgeProps> = {
    [Insurance.INSURANCE_INSURED]: {
        text: 'Insured',
        variant: 'active',
        icon: 'fa-solid fa-shield-check',
    },
    [Insurance.INSURANCE_PENDING]: {
        text: 'Pending insurance',
        variant: 'warning',
        icon: 'fa-solid fa-shield-exclamation',
    },
    [Insurance.INSURANCE_ACTION_REQUIRED]: NOT_INSURED_PROPS,
    [Insurance.INSURANCE_NOT_INSURED]: NOT_INSURED_PROPS,
    [Insurance.INSURANCE_DISABLED]: {
        ...NOT_INSURED_PROPS,
        text: 'Insurance disabled',
    },
};

export { InsuranceBadge };
export default InsuranceBadge;
